var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2304 7.14801H2.10186C1.88853 7.14809 1.67743 7.20227 1.49071 7.30548C1.304 7.40868 1.1465 7.55755 1.03295 7.73815C0.919391 7.91876 0.853484 8.12521 0.841386 8.33821C0.829288 8.5512 0.871396 8.76379 0.963771 8.95609L2.78068 12.7413C2.88358 12.9555 3.04487 13.1363 3.24599 13.2629C3.44711 13.3894 3.67988 13.4566 3.91751 13.4567H11.4148C11.6524 13.4566 11.8852 13.3894 12.0863 13.2629C12.2874 13.1363 12.4487 12.9555 12.5516 12.7413L14.3685 8.95609C14.461 8.76369 14.5031 8.55099 14.4909 8.33789C14.4787 8.12479 14.4127 7.91826 14.299 7.73762C14.1853 7.55698 14.0277 7.40814 13.8408 7.30502C13.6539 7.2019 13.4439 7.14788 13.2304 7.14801Z",
    stroke: "#192227",
    strokeWidth: 1.67855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14265 7.148L4.15849 4.19299C4.12695 4.09831 4.11833 3.99748 4.13333 3.89882C4.14833 3.80015 4.18653 3.70644 4.24478 3.6254C4.30304 3.54437 4.37969 3.47831 4.46843 3.43265C4.55718 3.38699 4.6555 3.36304 4.7553 3.36277H10.5745C10.6745 3.36264 10.7731 3.3863 10.8622 3.43179C10.9512 3.47727 11.0282 3.54329 11.0868 3.62438C11.1453 3.70548 11.1837 3.79933 11.1989 3.89819C11.214 3.99706 11.2054 4.0981 11.1738 4.19299L10.1896 7.148M7.66614 0.839279V3.36277M5.14265 13.4567V24.8124H10.1896V13.4567M1.35742 24.8124H24.0688",
    stroke: "#192227",
    strokeWidth: 1.67855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1899 19.7655H19.0221C19.6914 19.7655 20.3333 20.0313 20.8065 20.5046C21.2798 20.9778 21.5456 21.6197 21.5456 22.2889V24.8124",
    stroke: "#192227",
    strokeWidth: 1.67855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.185c20bfa9af76fba11d9c72b1f712e7.svg";
export { ForwardRef as ReactComponent };